import React from 'react';
import {style, classes} from './doppe-viewer-map-directions.st.css';
import {flexColumn, RichTextContent} from "@wix/devzai-utils-react";
import { DoppeHideableValue } from '../../../client-server-common';
import {
    DoppeActionTypeWidgetInnerDescription
} from "../../doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description";
import {doppeAppLayoutGap} from "@wix/doppe-ui";

export const DoppeViewerMapDirections = React.memo(function DoppeViewerMapDirections (props: DoppeViewerMapDirections.Props) {
    const {
        className,
        directionsTitle,
        directions,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, flexColumn(), doppeAppLayoutGap(8), className)}
        >
            <div className={classes.title}>{directionsTitle}</div>
            <div className={classes.details}>
                <DoppeActionTypeWidgetInnerDescription
                    maxLines={6}
                >
                    {directions}
                </DoppeActionTypeWidgetInnerDescription>
            </div>
        </div>
    );
});

export namespace DoppeViewerMapDirections {
    export interface Props extends React.HTMLAttributes<any> {
        directionsTitle: string;
        directions: DoppeHideableValue<RichTextContent>;
    }
}
